<template>
  <v-container class="mb-8">
    <v-row>
      <v-col cols="12"><slot name="header"/></v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12">
        <v-card class="card">
          <slot name="content" />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ReviewBoosterContainer"
};
</script>
<style lang="scss">
.card {
  min-height: 589px;
  position: relative;
  padding: $spacing * 3;
}
</style>
